/* eslint-disable no-console */
import dayjs from "dayjs";
import log from "loglevel";

const ENABLE_LOG = true;
const DATE_FORMAT = "MM/DD/YY hh:mm A";

export const logError = (logData: any) => {
  if (ENABLE_LOG) {
    const currentTime = dayjs(new Date()).format(DATE_FORMAT);
    if (typeof logData === "string") {
      log.error(`${currentTime} ${logData}`);
    } else {
      log.error(`${currentTime}`, logData);
    }
  }
};

export const logDebug = (logData: any) => {
  if (ENABLE_LOG) {
    const currentTime = dayjs(new Date()).format(DATE_FORMAT);
    if (typeof logData === "string") {
      log.debug(`${currentTime} ${logData}`);
    } else {
      log.debug(`${currentTime}`, logData);
    }
  }
};

export const logInfo = (logData: any) => {
  if (ENABLE_LOG) {
    const currentTime = dayjs(new Date()).format(DATE_FORMAT);
    if (typeof logData === "string") {
      log.info(`${currentTime} ${logData}`);
    } else {
      log.info(`${currentTime}`, logData);
    }
  }
};
export const logWarn = (logData: any) => {
  if (ENABLE_LOG) {
    const currentTime = dayjs(new Date()).format(DATE_FORMAT);
    if (typeof logData === "string") {
      log.warn(`${currentTime} ${logData}`);
    } else {
      log.warn(`${currentTime}`, logData);
    }
  }
};
export const logTrace = (logData: any) => {
  if (ENABLE_LOG) {
    const currentTime = dayjs(new Date()).format(DATE_FORMAT);
    if (typeof logData === "string") {
      log.trace(`${currentTime} ${logData}`);
    } else {
      log.trace(`${currentTime}`, logData);
    }
  }
};

export const logScreenVisit = (logData: any) => {
  const currentTime = dayjs(new Date()).format(DATE_FORMAT);
  log.info(`${currentTime} Screen Visited: `, logData);
};
